<form [formGroup]="form">
  <mat-form-field class="item">
    <mat-label>
      {{ 'CREATE_USER.FIRST_NAME' | translate }}
    </mat-label>
    <input matInput formControlName="first_name" autocomplete="false" />
  </mat-form-field>

  <mat-form-field class="item">
    <mat-label>
      {{ 'CREATE_USER.LAST_NAME' | translate }}
    </mat-label>
    <input matInput formControlName="last_name" autocomplete="false" />
  </mat-form-field>

  <glxy-phone-input class="item" [formControl]="form.controls.phone" [required]="false"></glxy-phone-input>

  <mat-form-field class="item">
    <mat-label>
      {{ 'CREATE_USER.EMAIL' | translate }}
    </mat-label>
    <input matInput data-testid="user-email" formControlName="user_email" />
  </mat-form-field>
</form>
